import { Controller } from "@hotwired/stimulus"

// The shop confirmation while a subscription line is being charged (card 12): reloads the page once
// the charge job has run (its broadcast swaps this element for a done one), or every 10 s when no
// broadcast arrives (no WebSocket, or the job ended before the page subscribed). Each reload counts
// in ?refresh=, which the server stops showing this element at, so it never loops for good.
export default class extends Controller {
  static values = { done: Boolean }

  connect() {
    this.timer = setTimeout(() => this.reload(), this.doneValue ? 0 : 10000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  reload() {
    const url = new URL(window.location.href)
    url.searchParams.set("refresh", (parseInt(url.searchParams.get("refresh"), 10) || 0) + 1)
    window.location.replace(url.toString())
  }
}
